import React, { useEffect, useState } from 'react';

import './Postos.css';

import { toast } from 'react-toastify';

import iPosto from '../interfaces/iPosto';



const Postos = ({ setCurrentPage, isAuthenticated }: { setCurrentPage?: Function, isAuthenticated: boolean; }) => {

    const apiUrl = process.env.REACT_APP_API_URL;

    const [tipoModal, setTipoModal] = useState<'editar' | 'criar'>('editar');
    const [postosList, setPostosList] = useState<iPosto[]>([]);
    const [excluirInput, setExcluirInput] = useState<string>('');
    const [excluirId, setExcluirId] = useState<string>('');

    const [postoInputs, setPostoInputs] = useState<iPosto>({
        posto_id: '',
        posto_nome: '',
        posto_lat: '',
        posto_lon: '',
        posto_alt: '',
    });
    const { posto_nome, posto_lat, posto_lon, posto_alt } = postoInputs;

    const clearInputs = () => {
        setPostoInputs({
            posto_id: '',
            posto_nome: '',
            posto_lat: '',
            posto_lon: '',
            posto_alt: '',
        });
        setExcluirId('');
        setExcluirInput('');
    };

    const handleInit = async () => {
        try {
            const response = await fetch(`${apiUrl}/all-postos`);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const jsonResponse = await response.json();
            setPostosList(jsonResponse);
        } catch (err) {
            console.error("Failed to fetch postos:", err);
        }
    };

    const handleInputChanges = (element: any) => {
        setPostoInputs({ ...postoInputs, [element.target.name]: element.target.value });
    };

    const handleEditar = (posto: iPosto) => {
        setTipoModal("editar");
        setPostoInputs(posto);
    };

    const handleCriar = () => {
        setTipoModal("criar");
    };

    const handleSubmit = () => {
        tipoModal === 'editar' ?
            handleEditarPosto() :
            handleCriarPosto();
        clearInputs();
    };

    const handleEditarPosto = async () => {
        try {
            const body = postoInputs;
            const res = await fetch(`${apiUrl}/update-posto`,
                {
                    method: "PUT",
                    headers: { "Content-Type": "application/json", token: localStorage.token },
                    body: JSON.stringify(body)
                });
            if (res.status === 200) {
                toast.success("Posto editato!");
            } else {
                toast.error("Posto não editado!");
            }
            handleInit();
        } catch (err: any) {
            console.error(err.message);
        }
    };

    const handleCriarPosto = async () => {
        try {
            const body = postoInputs;
            const res = await fetch(`${apiUrl}/create-posto`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json", token: localStorage.token },
                    body: JSON.stringify(body)
                });
            if (res.status === 200) {
                toast.success("Posto inserido!");
            } else {
                toast.error("Posto não inserido!");
            }
            handleInit();
        } catch (err: any) {
            console.error(err.message);
        }
    };

    const handleExcluirPosto = async (id: string) => {
        setExcluirInput('');
        try {
            const res = await fetch(`${apiUrl}/delete-posto/${id}`,
                {
                    method: "DELETE",
                    headers: { "Content-Type": "application/json", token: localStorage.token }
                });
            if (res.status === 200) {
                toast.success("Posto excluido!");
            } else {
                toast.error("Posto não excluido!");
            }
            handleInit();
        } catch (err: any) {
            console.error(err.message);
        }
        setExcluirId('');
    };

    useEffect(() => {
        if (setCurrentPage) {
            setCurrentPage(window.location.pathname);
            handleInit();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className=" d-flex flex-column align-items-center">
            <div className="css-postos-card card mt-4">
                <h5 className="card-header text-center">Postos</h5>
                <div className="card-body overflow-scroll">
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Posto</th>
                                <th scope="col">Latitude</th>
                                <th scope="col">Logitude</th>
                                <th scope="col">Altitude</th>
                                <th scope="col"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {postosList.map((posto: iPosto, index: number) =>
                                <tr key={posto.posto_id} className="text">
                                    <th scope="row" className="align-middle">{index + 1}</th>
                                    <td className="align-middle">{posto.posto_nome}</td>
                                    <td className="align-middle">{posto.posto_lat}</td>
                                    <td className="align-middle">{posto.posto_lon}</td>
                                    <td className="align-middle">{posto.posto_alt}</td>
                                    <td>
                                        {isAuthenticated &&
                                            <div className="d-flex">
                                                <button className="btn btn-warning" type="button" data-bs-toggle="modal" data-bs-target="#modalPosto" onClick={() => handleEditar(posto)}>
                                                    editar
                                                </button>
                                                <button type="button" className="btn btn-danger ms-1" data-bs-toggle="modal" data-bs-target="#modalExcluir" onClick={() => setExcluirId(posto.posto_id)}>
                                                    excluir
                                                </button>
                                            </div>
                                        }
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            {isAuthenticated && <button className='btn bg-primary text-white m-3' type="button" data-bs-toggle="modal" data-bs-target="#modalPosto" onClick={handleCriar}>Novo posto</button>}

            <div className="modal fade" id="modalPosto" tabIndex={-1} aria-labelledby="modalPostoLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard={false}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="modalPostoLabel">{tipoModal === 'editar' ? 'Editar posto' : 'Criar posto'}</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={clearInputs}></button>
                        </div>
                        <div className="modal-body">
                            <form>
                                <div className="mb-3">
                                    <label htmlFor="nomeNovoDoPosto" className="form-label">Nome:</label>
                                    <input type="text" className="form-control" id="nomeNovoDoPosto" name="posto_nome" value={posto_nome} onChange={e => handleInputChanges(e)} />
                                </div>
                                <div className="d-flex">
                                    <div className="mb-3">
                                        <label htmlFor="latNovoDoPosto" className="form-label">Latitude:</label>
                                        <input type="text" className="form-control" id="latNovoDoPosto" name="posto_lat" value={posto_lat} onChange={e => handleInputChanges(e)} />
                                    </div>
                                    <div className="mb-3 ms-1 me-1">
                                        <label htmlFor="lonNovoDoPosto" className="form-label">Longitude:</label>
                                        <input type="text" className="form-control" id="lonNovoDoPosto" name="posto_lon" value={posto_lon} onChange={e => handleInputChanges(e)} />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="altNovoDoPosto" className="form-label">Altitude:</label>
                                        <input type="text" className="form-control" id="altNovoDoPosto" name="posto_alt" value={posto_alt} onChange={e => handleInputChanges(e)} />
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={clearInputs}>Cancelar</button>
                            <button type="button" disabled={postoInputs.posto_nome.trim().length <= 0} className="btn btn-primary" data-bs-dismiss="modal" onClick={handleSubmit}>{tipoModal === 'editar' ? 'Salvar' : 'Criar'}</button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="modalExcluir" tabIndex={-1} aria-labelledby="modalExcluirLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard={false}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="modalExcluirLabel">Excluir posto</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={clearInputs}></button>
                        </div>
                        <div className="modal-body">
                            <h5 className='text-center mb-3'>ATENÇÃO</h5>
                            <h6 className='mb-5'>Ao excluir um posto, <span className='text-danger'>TODOS</span> os dados desse posto também serão excluídos!</h6>
                            <p>Para prosseguir digite: <span className="badge text-bg-danger">EXCLUIR POSTO E DADOS</span></p>
                            <div className="input-group mb-3">
                                <input type="text" className="form-control" placeholder="..." value={excluirInput} onChange={e => setExcluirInput(e.target.value)} />
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={clearInputs}>Cancelar</button>
                            <button type="button" className="btn btn-danger" data-bs-dismiss="modal" disabled={excluirInput !== `EXCLUIR POSTO E DADOS`} onClick={() => handleExcluirPosto(excluirId)}>Excluir permanentemente</button>
                        </div>
                    </div>
                </div>
            </div>

        </div >
    );
};

export default Postos;
